<template>
    <div class="row endpoint-route">
        <div class="col-12 col-md-3 order-md-last">
            <multiselect v-model="selectedMethod"
                         :options="methods"
                         :close-on-select="true"
                         :hide-selected="false"
                         :preserve-search="true"
                         placeholder="METHOD">
                <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                        <span>{{ props.option }}</span>
                        <span class="custom__remove"
                              @click="props.remove(props.option)">
                            ❌
                        </span>
                    </span>
                </template>
            </multiselect>
        </div>
        <div class="col-12 col-md-9 order-md-first">
            <div v-for="(method, methodKey) in route"
                 :key="method[methodKey]"
                 v-if="selectedMethod === 'all' || !selectedMethod || selectedMethod === methodKey">
                <h4>Route: {{endpointName}}</h4>
                <h5>Method: {{methodKey}} </h5>
                <div class="row"
                     :key="fieldKey"
                     v-for="(field, fieldKey) in method">
                    <api-endpoint-route-field :field="field"
                                              :field-key="fieldKey"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiEndpointRouteField from './ApiEndpointRouteField';
import Multiselect from 'vue-multiselect';

export default {
    name: 'api-endpoint-route',
    components: {
        ApiEndpointRouteField,
        Multiselect
    },
    data () {
        return {
            selectedMethod: 'all',
            methods: []
        };
    },
    props: {
        route: {},
        endpointName: {}
    },
    created () {
        this.methods = ['all', ...Object.keys(this.route)];
    }
    
};
</script>
